 <!--
 * @Author: zhonghao
 * @Date: 2023-09-12 09:55:37
-->
<template>
  <div class="block-con" v-if="title || hasAIFV || hasActivity || zoneLive">
    <div class="live-block" v-if="title" @click="handleClick" v-track="{ functionName: '首页-直播按钮' }">
      <div class="live-left">
        <img src="../../../assets/images/home/icon_live@2x.png" class="live-icon" alt="">
        <span class="live-title">直播:</span>
        <span class="live-txt">{{ title }}</span>
      </div>
      <div class="live-time">
        {{ time }}
        <img src="../../../assets/images/home/icon_more@2x.png" class="icon-more" alt="">
      </div>
    </div>
    <div class="live-block" v-if="zoneLive && Object.keys(zoneLive).length > 0" v-track="{ functionName: '首页-专区直播按钮' }" @click="handleClickZone">
      <div class="live-left">
        <img src="../../../assets/images/home/icon_live@2x.png" class="live-icon" alt="">
        <span class="live-title live-title2">专区直播:</span>
        <span class="live-txt">{{ zoneLive && zoneLive.meetingName }}</span>
      </div>
      <div class="live-time">
        {{ zoneLive && zoneLive.times }}
        <img src="../../../assets/images/home/icon_more@2x.png" class="icon-more" alt="">
      </div>
    </div>
    <div class="news-block" :class="title ? 'hr' : ''" v-if="hasAIFV">
      <div class="my-swipe-item" v-if="hasAIFV" v-track="{ functionName: 'AIFV' }" @click="handleJump('aifv')">
        <img src="../../../assets/images/home/icon_news@2x.png" class="icon-news" alt="">
        <div class="news-title">
          <!-- 您有{{aifvList.length}}条新的 -->
          您有1条新的
          <span style="color: #EB1700;">AIFV</span>
          报告,待查看
        </div>
        <img src="../../../assets/images/home/icon_more@2x.png" class="icon-more" alt="">
      </div>
    </div>
    <div class="news-block" :class="title ? 'hr' : ''" v-if="hasActivity">
      <div class="my-swipe-item" v-if="hasActivity" v-track="{ functionName: '学术活动' }" @click="handleJump('activity')">
        <img src="../../../assets/images/home/icon_news@2x.png" class="icon-news" alt="">
        <div class="news-title">
          您有{{ activityList && activityList.length }}场新的
          <span style="color: #EB1700;">学术活动</span>
          ,待查看
        </div>
        <img src="../../../assets/images/home/icon_more@2x.png" class="icon-more" alt="">
      </div>
    </div>
  </div>
</template>
<script>
import { getLiveList, selectActivityRead, getAifvPushRecordIsRead } from '@/api/api'
// import { setSha } from '../../../utils/util'
import { getMeetingHome } from '@/api/zone'
export default {
  data () {
    return {
      title: '',
      time: '',
      results: [],
      hasActivity: false,
      hasAIFV: false,
      aifvList: [],
      activityList: [],
      zoneLive: {}
    }
  },
  computed: {
    userInfo () {
      return this.$store.getters.userInfo
    }
  },
  mounted () {
    getLiveList({
      openId: this.userInfo.iepOpenId
    }).then(res => {
      this.results = res.data.list
      if (this.results.length > 0) {
        this.title = this.results[0].title
        this.time = this.$moment(this.results[0].start * 1).format('MM-DD')
      }
    })
    getMeetingHome({userId: this.userInfo.id}).then(res => {
      if (!res.data) return
      this.zoneLive = res.data
      this.zoneLive.times = this.$moment(this.zoneLive.startTime * 1).format('MM-DD')
    })
    this.handleFun()
  },
  methods: {
    handleFun () {
      selectActivityRead({
        userId: this.userInfo.id,
      }).then(res => {
        this.activityList = res.data
        if (res.data.length > 0) {
          this.hasActivity = true
          this.activity = res.data[0]
        }
      })
      if (this.userInfo.multiCode) {
        getAifvPushRecordIsRead({
          multiCode: this.userInfo.multiCode,
          // isRead: 2
        }).then(res => {
          if (res.data === 0) return
          this.hasAIFV = true
          // this.aifv = res.data.list[0]
          // this.aifvList = res.data.list
          // if (res.data.list.length > 0) {
          //   this.hasAIFV = true
          //   this.aifv = res.data.list[0]
          // }
        })
      }
    },
    handleClick () {
      if (this.results.length > 1) {
        this.$router.push({
          path: '/liveList'
        })
      } else {
        localStorage.setItem('functionUrl', `${process.env.baseURL}${process.env.BASE_URL}/liveDetails?liveId=${this.results[0].id}&entrance=97&channel=97`)
        this.$router.push({
          path: '/liveDetails',
          query: {
            liveId: this.results[0].id,
            entrance: 97,
            channel: 97,
          },
        })
      }
    },
    handleClickZone() {
      if (`${this.zoneLive.meetingType}` === '1') {
        localStorage.setItem('functionUrl', `${process.env.baseURL}${process.env.BASE_URL}/liveDetails?liveId=${this.zoneLive.meetingLink}&entrance=98&channel=98`)
        this.$router.push({
          path: '/liveDetails',
          query: {
            liveId: this.zoneLive.meetingLink,
            entrance: 98,
            channel: 98,
          },
        })
      } else {
        window.location.href = this.zoneLive.meetingLink
      }
    },
    handleJump (type) {
      switch (type) {
        case 'activity':
          if (this.activityList.length > 1) {
            this.$router.push({
              path: `/train`
            })
            return
          }
          localStorage.setItem('functionUrl', `${process.env.baseURL}${process.env.BASE_URL}/train/trainDetails?trainId=${this.activity.academicActivityId}&hospitalId=${this.activity.hospitalId}`)
          this.$router.push({
            path: `/train/trainDetails?trainId=${this.activity.academicActivityId}&hospitalId=${this.activity.hospitalId}`
          })
          break
        case 'aifv':
          if (this.hasAIFV) {
            this.$router.push({
              path: `/aifv`,
              query: {
                isMessage: true
              }
            })
          }
          localStorage.setItem('functionUrl', `${process.env.baseURL}${process.env.BASE_URL}/pdfView?code=${this.aifv.fileId}`)
          this.$router.push({
            path: `/pdfView?code=${this.aifv.fileId}`
          })
          break

        default:
          break
      }
    }
  }
}
</script>
<style lang="less" scoped>
.block-con {
  background-color: #F9F8F7;
  border-radius: 8px;
  margin: 0 14px;
  width: calc(100% - 28px);

  .live-block,
  .news-block {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .live-block {
    height: 38px;
    padding: 0 20px 0 13px;
    box-sizing: border-box;

    .live-left {
      display: flex;
      align-items: center;
      flex: 1;
      width: calc(100% - 120px);

      .live-icon {
        width: 15px;
        height: 15px;
        display: block;
        margin-right: 4px;
      }

      .live-title {
        font-size: 13px;
        color: #EB1700;
        display: block;
        margin-right: 4px;
        min-width: 30px;
        &.live-title2 {
          min-width: 60px;
        }
      }

      .live-txt {
        display: block;
        font-size: 13px;
        color: #000000;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }

    .live-time {
      display: flex;
      align-items: center;
      font-size: 13px;
      color: #6A7481;
      min-width: 100px;
      max-width: 120px;
      justify-content: flex-end;

      .icon-more {
        width: 16px;
        height: 16px;
        display: block;
        margin-left: 10px;
      }
    }
  }

  .news-block {
    box-sizing: border-box;
    padding-right: 20px;
    box-sizing: border-box;
    padding-left: 13px;

    &.hr {
      border-top: 1px solid #CFD3DA;
    }

    .my-swipe-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      .icon-news {
        width: 15px;
        height: 15px;
        display: block;
        margin-right: 4px;
      }
      .news-title {
        display: flex;
        height: 42px;
        align-items: center;
        font-size: 13px;
        color: #000000;
        position: relative;
        box-sizing: border-box;
        flex: 1;
      }

      .icon-more {
        width: 16px;
        height: 16px;
        display: block;
      }
    }

  }

}</style>



// WEBPACK FOOTER //
// src/views/home/components/Live.vue